var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBrandFacebook = function SvgBrandFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand-facebook_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M12.5.9C5.873.9.5 6.273.5 12.9c0 5.628 3.875 10.35 9.101 11.647v-7.98H7.127V12.9H9.6v-1.58c0-4.084 1.849-5.977 5.859-5.977.76 0 2.072.15 2.608.298v3.324c-.283-.03-.775-.045-1.386-.045-1.967 0-2.728.746-2.728 2.683V12.9h3.92l-.673 3.668h-3.247v8.245C19.896 24.095 24.5 19.036 24.5 12.9c0-6.627-5.373-12-12-12"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "brand-facebook_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5.9h24v24H.5z"
  })))));
};
export default SvgBrandFacebook;